import "./Login.scss";
import Cookies from "js-cookie";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";

function Login() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  return (
    <div className="loginContainer">
      <h1>Accéder à mon espace Admin</h1>
      <div className="loginBottom">
        <input
          onChange={(e) => setPassword(e.target.value)}
          type="text"
          placeholder="Saisir votre mot de passe"
        />
        <Button
          text={"Se connecter"}
          color={"green"}
          func={() => {
            if (password === "admin") {
              Cookies.set("status", "connected");
              navigate("/backoffice");
            } else {
              alert("Mot de passe erroné");
            }
          }}
          show={true}
        />
      </div>
    </div>
  );
}

export default Login;
